"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLunchGroupItem = exports.isLunchItem = exports.SpecialDiet = exports.LunchListWeekDay = void 0;
/** Possible days for lunch list */
var LunchListWeekDay;
(function (LunchListWeekDay) {
    LunchListWeekDay["sun"] = "sun";
    LunchListWeekDay["mon"] = "mon";
    LunchListWeekDay["tue"] = "tue";
    LunchListWeekDay["wed"] = "wed";
    LunchListWeekDay["thu"] = "thu";
    LunchListWeekDay["fri"] = "fri";
    LunchListWeekDay["sat"] = "sat";
})(LunchListWeekDay = exports.LunchListWeekDay || (exports.LunchListWeekDay = {}));
var SpecialDiet;
(function (SpecialDiet) {
    SpecialDiet["dairyFree"] = "dairyFree";
    SpecialDiet["glutenFree"] = "glutenFree";
    SpecialDiet["lactoseFree"] = "lactoseFree";
    SpecialDiet["lowLactose"] = "lowLactose";
    SpecialDiet["eggFree"] = "eggFree";
    SpecialDiet["vegetarian"] = "vegetarian";
    SpecialDiet["vegan"] = "vegan";
})(SpecialDiet = exports.SpecialDiet || (exports.SpecialDiet = {}));
/** Type guard for lunch item */
exports.isLunchItem = (item) => item.productId;
/** Type guard for lunch group */
exports.isLunchGroupItem = (item) => item.groupId;
//# sourceMappingURL=lunchLists.js.map